"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSON_ID_KEYNAME = exports.JSON_SURVEY_KEYNAME = exports.DOM_ID_TAGNAME = exports.DOM_TYPE_VALUE = exports.DOM_TYPE_TAGNAME = exports.SurveyInfoBusinessLevel = void 0;
var SurveyInfoBusinessLevel;
(function (SurveyInfoBusinessLevel) {
    SurveyInfoBusinessLevel[SurveyInfoBusinessLevel["None"] = 0] = "None";
    SurveyInfoBusinessLevel[SurveyInfoBusinessLevel["Critical"] = 1] = "Critical";
})(SurveyInfoBusinessLevel = exports.SurveyInfoBusinessLevel || (exports.SurveyInfoBusinessLevel = {}));
exports.DOM_TYPE_TAGNAME = "Type";
exports.DOM_TYPE_VALUE = "Survey";
exports.DOM_ID_TAGNAME = "SurveyID";
exports.JSON_SURVEY_KEYNAME = "survey";
exports.JSON_ID_KEYNAME = "surveyId";
